import React, { useContext, useRef, useState } from 'react'
import classNames from 'classnames'
import Groupe from '../assets/Group.svg'
import Vector from '../assets/Vector.svg'
import Close from '../assets/close.svg'
import { Link, useNavigate } from 'react-router-dom'
import HomeIcon from '../assets/iconAccueil.svg'

import RechargeIcon from '../assets/iconRecharge.svg'
import TransfertIcon from '../assets/iconTransfertCash.svg'
import BenifIcon from '../assets/iconBeneficiary.svg'
import IconWalletMobile from '../assets/iconWalletMobile.svg'
import LogOutIcon from '../assets/iconLogout.svg'
import ModalLogOutContainer from 'containers/logOutContainer/modalLogOutContainer'
import logoMyEasyMobile from '../assets/logoMyEasyMobile.svg'
import RechargeCartePrepayeeIcon from '../assets/cartePrepayeeIconBlanc.svg'
import iconAssuranceResponsive from '../assets/iconAssuranceResponsive.svg'
import DrapeuTUN from '../assets/flagTND.svg'

import DrapeuSEN from '../assets/flegSEN.svg'
import DrapeuMAC from '../assets/flagMAC.svg'
import DrapeuALG from '../assets/flagALGR.svg'
import DrapeuTRK from '../assets/drapeauRounded/flagTRK.svg'
import DrapeuPKR from '../assets/drapeauRounded/flagPKR.svg'
import DrapeuABDT from '../assets/drapeauRounded/flagBDT.svg'

import assuranceIconBanque from '../assets/assuranceIconBanque.svg'
import compteBanqueIconMobile from '../assets/iconTransfertCompteBancaire.svg'
import HistoriqueIconMobile from '../assets/iconHistory.svg'
import PaiementIconManque from '../assets/PaiementIconManque.svg'
import UserContext from 'contexts/UserContext'
import useOnclickOutside from 'hooks/useOnclickOutside'
import { useTranslation } from 'react-i18next'
export default function NavbarMobile() {
  const currentPath=location.pathname
  const {user}=useContext(UserContext)
   const destinationDefaultCountry=user?.user?.destinationDefaultCountry
  const listeDrapeu=[
    {pays:'TUN', flag:DrapeuTUN},
    {pays:'SEN', flag:DrapeuSEN},
    {pays:'MAC', flag:DrapeuMAC},
    {pays:'ALG', flag:DrapeuALG},
    {pays:'PKR', flag:DrapeuPKR},
    {pays:'TRY', flag:DrapeuTRK},
    {pays:'BDT', flag:DrapeuABDT},
  ]
const OrderListe=[
  ...listeDrapeu.filter(item=>destinationDefaultCountry=== item.pays),
  ...listeDrapeu.filter(item=>destinationDefaultCountry!== item.pays)
]
  const [isOpen, setIsOpen]=useState(false)
  const refFlag=useRef<HTMLDivElement>(null)
  const toggleSetting=()=>setIsOpen(false)
  useOnclickOutside(toggleSetting, refFlag)
  const[openModalLogOut, setOpenModalLogOut] = useState(false)
  const closeModal = () =>{
    setOpenModalLogOut(false)
  }
    const { t } = useTranslation()
 
  const [open, setOpen] = useState(true)
  const Links: { img: string; name: string; link: string }[] = [
    { img: HomeIcon, name: t("ServiceList.home"), link: '/' },
    { img: PaiementIconManque, name: t("ServiceList.billPayment"), link: '/paimentFacture' },
    { img: TransfertIcon, name: t("ServiceList.cashTransfer"), link: '/transfert/0' },
    { img: compteBanqueIconMobile, name: t("ServiceList.bankTransfer"), link: '/transfert/1' },
    { img: IconWalletMobile, name: t("ServiceList.walletTransfer"), link: '/transfert-vers-wallet' },
    { img: RechargeCartePrepayeeIcon, name: t("ServiceList.prepaidCardRecharge"), link: '/rechargeCartePrepayee' },
    { img: RechargeIcon, name: t("ServiceList.mobileRecharge"), link: '/recharge' },
    { img: iconAssuranceResponsive, name: t("ServiceList.localInsurance"), link: '/assurance' },
    { img: BenifIcon, name: t("ServiceList.beneficiaries"), link: '/beneficiary' },
    { img: HistoriqueIconMobile, name: t("ServiceList.history"), link: '/history' },

  ]
 
  
  return (
    <div className={classNames('hidden lg:block w-full ', !open && 'fixed overflow-hidden  z-50 ')}>
      <div className={classNames('  bg-[#5754E5] ', open ? 'h-[85px] ' : ' relative h-screen overflow-y-auto ')}>
        <div
          className={classNames(!open && ' ', ` pt-5 flex items-center justify-between `)}
        >
          <Link to='/' className="pl-5">
            <img  width={130} height={42} src={logoMyEasyMobile} alt="" />
          </Link>
          
          <div className='flex items-start  absolute top-0  right-0'>
            <div className={` ${!open && 'hidden'} h-[80px] text-white flex items-center mr-4  font-semibold  `}>
              {t('languages.code')}
            </div>
            
          {(currentPath=='/' || currentPath==='/settingProfile/0' ) && open && 
            <div ref={refFlag} className=' z-30 mt-[15px] w-[50px] ' >
              {!isOpen 
              ?
              <img onClick={()=>{setIsOpen(!isOpen)}} className=' m-2 cursor-pointer border-2 border-[#FFF] rounded-full ' 
              width={35} height={35}
              src={OrderListe[0].flag} 
               alt=''/>
            :
            <div className='bg-[#FFF] rounded-3xl p-2 gap-2 h-full flex flex-col items-center overflow-y-auto max-h-[180px] scrollbar-hide shadow-[0px_0px_6px_rgba(66,46,174,0.4)]'>
              {OrderListe.map((item, index)=>(
             <div key={index} className={`${item.pays === destinationDefaultCountry && ' border border-[#5754E5] rounded-full'}`}>
            <img  
              onClick={()=>{if(item.pays === destinationDefaultCountry){setIsOpen(false)}}}
              className={`${item.pays !== destinationDefaultCountry ? 'opacity-50 cursor-default shadow-selct shadow-[#5754E5]/35' : 'cursor-pointer border-2 border-[#FFF] rounded-full'}  rounded-full `}
              width={35} height={35}
              src={item.flag} alt=''
            />
            </div>

          ))}

          </div>
          }
            </div>
          }
          
          
           <img
            className={classNames(!open &&'hidden')}
            width={80}
            height={80}
            onClick={() => setOpen(!open)}
            src={Groupe}
            alt=""
          /> 
          </div>
          
          {/* <img src={Bell} alt="" className={classNames('absolute ', open ? 'right-12' : 'hidden')} />
          <img src={Message} alt="" className={classNames('absolute ', open ? 'right-4' : 'hidden')} /> */}
          <img
            className={classNames('absolute ', open ? 'hidden' : ' right-8 w-[20px] h-auto')}
            width={25}
            height={25}
            onClick={() => setOpen(!open)}
            src={Close}
            alt=""
          />
        </div>

          <div className='h-full '>
            <ul className={classNames(`flex gap-2  flex-col mt-10 `,  open && 'hidden')}>
              {Links.map((v, index: number) => (
                <li
                  key={index}
                  className={ classNames(location.pathname === v.link && ' bg-[#4D36CC]',` text-[#FFFF] flex items-center pl-5 h-[50px] hover:text-[#58575b] font-bold text-[22px] sm:text-[16px]`)}
                  onClick={() => setOpen(!open)}
                >
                  <Link to={v.link} className={`flex items-center gap-4`}>
                    <img width={30} height={30} className='sm:w-[25px] sm:h-full'  alt="" src={v.img} />
                    {v.name}
                  </Link>
                </li>
              ))}
              <div
                onClick={() => {
                  setOpenModalLogOut(true)
                }}
                className="flex pl-5 items-center gap-4 hover:cursor-pointer text-[#FFFF] hover:text-[#58575b]   text-white font-bold text-[22px] sm:text-[16px] "
              >
                <img alt="" width={30} height={30} className='sm:w-[25px] sm:h-full' src={LogOutIcon} />
                 Déconnexion
              </div>
            </ul>
            <ModalLogOutContainer isOpen={openModalLogOut} closeModal={closeModal} openModalLogOut={openModalLogOut}/>
            { !open && <img className=" right-0 top-1/2  absolute " width={160} height={160} src={Vector} alt="" />}        

          </div>
        
      </div>
    </div>
  )
}
